import { config } from "../../../../../config";
import http from "../../../../../http";
import { GET_TIRE_BRAND_BEGIN, GET_TIRE_BRAND_SUCCESS } from "./type";
import { hasErrors } from "../../../error/actions";

export const getTireBrand = () => {
    return async dispatch => {
        try {
            dispatch(getBegin())
            const result = await http.get(config.api.COMMON.TIRE.GET_TIRE_BRANDS)
            dispatch(getSuccess(result))
        } catch (error) {
            dispatch(hasErrors(error))
        }
    }
}

const getBegin = () => {
    return dispatch => {
        dispatch({ type: GET_TIRE_BRAND_BEGIN })
    }
}
const getSuccess = (items) => {
    return dispatch => {
        dispatch({ type: GET_TIRE_BRAND_SUCCESS, payload: { items, loading: false } })
    }
}